import type { PostOrdergrooveAddSubscription } from '@libs/common-next';
import { AUTOSHIP_ONE_TIME_OPTION } from '@libs/common-types';

export type AddSubscriptionFormValues = {
    quantity: number;
    autoshipFrequency: string;
    autoshipUnit: string;
};

type BuildAddSubscriptionPayloadParams = {
    customerUuid?: string | null;
    sku?: string | null;
    basketId?: string | null;
    nextSubscriptionOrderId?: string | null;
    form: AddSubscriptionFormValues;
};

/**
 * Builds the OrderGroove "add to next Autoship order" request, or `null` when the shopper has no
 * customer id, product, or upcoming order to add to. One-time items send no cadence.
 */
export const buildAddSubscriptionPayload = ({
    customerUuid,
    sku,
    basketId,
    nextSubscriptionOrderId,
    form,
}: BuildAddSubscriptionPayloadParams): PostOrdergrooveAddSubscription | null => {
    if (sku == null || !customerUuid || !nextSubscriptionOrderId) {
        return null;
    }

    const isOneTimeOrder = form.autoshipUnit === AUTOSHIP_ONE_TIME_OPTION.value;

    return {
        customerId: customerUuid,
        isOneTimeOrder,
        productId: sku,
        quantity: form.quantity,
        basketId: basketId ?? '',
        unitOfMeasure: isOneTimeOrder ? null : Number(form.autoshipUnit),
        frequencyAmount: isOneTimeOrder ? null : Number(form.autoshipFrequency),
        publicId: nextSubscriptionOrderId,
    };
};
